module.exports = __webpack_public_path__ + "static/media/logosNoMargin.a1249468.jpg";